import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { gsap, Elastic } from "gsap/all";
import { getGameStatus } from '../gameSlice';
import { useTranslation } from 'react-i18next';
import api from '../../../api';
import useReadCookies from "../../hooks/useReadCookies";


function SubGameTip ({ missionData }) 
{
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  let { cookiePlayerId, cookieGroupId } = useReadCookies();

  const currentMission = useSelector((state) => state.game.currentMission);

  const players = useSelector((state) => state.game.players);
  const [mainQuestionPlayer, setMainQuestionPlayer] = useState(null);

  let subGameTipRef = useRef(null);
  let hintRef = useRef(null);
  
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    if(missionData && currentMission !== null){
      let currentSubgameType = '';
      if(cookiePlayerId === missionData.mix_n_match_player){
        currentSubgameType = 'mix_n_match';
      }else if(cookiePlayerId === missionData.swipe_player){
        currentSubgameType = 'swipe';
      }
      
      api.completeSubGame(cookieGroupId,currentMission, currentSubgameType).then(response => {
        if(response.status === 200){
          dispatch(getGameStatus(cookieGroupId));
        }
      });
    }

  },[]);

  useEffect(() => {
    if(missionData && players){
      const mainQPlayer = players.filter(player => player.secret === missionData.main_question_player);
      setMainQuestionPlayer(mainQPlayer[0]);
    }
  }, [missionData, players]);

  const getTipImages = () => {
    if(missionData){
      if(cookiePlayerId === missionData.mix_n_match_player){
        return missionData.main_question.hint_1_image;
      }else if(cookiePlayerId === missionData.swipe_player){
        return missionData.main_question.hint_2_image;
      }
    }
  }

  const getTipText = () => {
    if(missionData){
      if(cookiePlayerId === missionData.mix_n_match_player){
        if(i18n.language === 'en'){
          return missionData.main_question.hint_1_en;
        }else{
          return missionData.main_question.hint_1_nl;
        }
        
      }else if(cookiePlayerId === missionData.swipe_player){
        if(i18n.language === 'en'){
          return missionData.main_question.hint_2_en;
        }else{
          return missionData.main_question.hint_2_nl;
        }
      }
    }
  }

  const getMainQuestionPlayerName = () => {
    return mainQuestionPlayer ? mainQuestionPlayer.name : '';
  }

  return (
    <>
    <div className="tip-image">
      <img src={getTipImages()} alt="tip"/>
    </div>
    <div className="tip-text">
      <p>{getTipText() && getTipText()}</p>
    </div>
    </>
  );
}

export default SubGameTip;